export const SERVICE_LEARNING_PROJECT = 'Service-Learning Project'
